var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"popupKeyboard",staticClass:"popup-keyboard"},[_c('div',{class:_vm.keyboardClass})])}
var staticRenderFns = []

export { render, staticRenderFns }